<template>
  <Modal
    class="scoped"
    hide-close-button
    :modal-style="{ width: '40%' }"
    title="Mentions"
  >
    <QCard class="full-width">
      <QCardSection class="scroll mentions-container q-mb-md no-wrap">
        <MentionStreamMentionPreview
          v-if="selectedMention"
          v-model:mention="selectedMention"
          class="mention-preview scroll"
          embeded-preview
          header
        />
        <div v-if="!selectedMention">
          <div v-if="!loading">
            <div
              v-for="result in mentions"
              :key="result.name"
              class="q-py-xs cursor-pointer"
            >
              <MentionCardFactory
                :mention="filteredResult(result)"
                @click="selectedMention = $event"
              />
            </div>
            <QPagination
              v-if="pageCount > 1"
              v-model="page"
              class="q-pa-sm"
              direction-links
              :max="pageCount"
              :max-pages="5"
              :min="1"
              @change="searchMentions"
              @update:model-value="searchMentions"
            />
          </div>
          <div
            v-else
            class="text-center"
          >
            <QSpinnerDots
              class="q-mt-lg"
              size="35px"
            />
          </div>
        </div>
      </QCardSection>
    </QCard>
    <template #buttons>
      <BaseButton
        class="q-px-md"
        color="primary"
        label="Close"
        @click="close"
      />
    </template>
  </Modal>
</template>

<script>
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";
import MentionCardFactory from "shared/components/MentionCardFactory";
import MentionStreamMentionPreview from "shared/components/MentionStreamMentionPreview.vue";

export default {
  name: "SearchMentionsModal",
  components: {
    BaseButton,
    Modal,
    MentionCardFactory,
    MentionStreamMentionPreview,
  },
  props: {
    query: {
      type: String,
      required: true,
    },
    sourceKey: {
      type: String,
      required: true,
    },
    after: {
      type: [Number, String],
      required: true,
    },
    before: {
      type: [Number, String],
      required: true,
    },
    media: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["close"],
  data() {
    return {
      mentions: [],
      page: 1,
      pageSize: 10,
      pageCount: 0,
      loading: false,
      selectedMention: null,
    };
  },
  mounted() {
    this.searchMentions();
  },
  methods: {
    async searchMentions() {
      try {
        this.loading = true;

        const response = await this.$streemApiAdmin.post("search", {
          params: {
            query: this.query,
            after: this.after,
            before: this.before,
            source_keys: [this.sourceKey],
            media: this.media,
            page: this.page,
            page_size: this.pageSize,
          },
        });

        this.mentions = response.data;
        this.pageCount = Number(response.headers["x-total-pages"]);
      } catch (error) {
        this.$error("Unable to find mentions", error);
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$emit("close");
    },
    filteredResult(result) {
      const filteredResult = result;

      if (result.thumbnails) {
        filteredResult.thumbnails = null;
      }

      return filteredResult;
    },
  },
};
</script>

<style lang="scss" scoped>
.mentions-container {
  height: 600px !important;
}
</style>
